
export interface IBadgeGroup {
  _id:string|undefined;
  name: string;
  desc: string;
  pointGoal: number;
  startDate:Date;
  endDate:Date;
  hidden: boolean;
}

export const defaultIBadgeGroup = ():IBadgeGroup => {
  return {
    _id: undefined,
    name:"A Badge Group",
    desc:"",
    pointGoal:0,
    startDate: new Date(),
    endDate: new Date(),
    hidden:true,
  }
}
